import { jsx as _jsx } from "react/jsx-runtime";
import React, { useMemo, useState } from 'react';
import { CANDY_APPLE, SORBET } from 'HubStyleTokens/colors';
import FormattedMessage from 'I18n/components/FormattedMessage';
import H1 from 'UIComponents/elements/headings/H1'; // @ts-expect-error untyped dependency

import CoreStorefrontHeader from 'ecosystem-marketplace-core/components/storefront/StorefrontHeader';
import SearchBar from './SearchBar';
export const HEADER_PADDING_Y = 48;
export default function HeaderSection({
  onTrackInteraction,
  paddingBottom = HEADER_PADDING_Y
}) {
  const [sticky, setSticky] = useState(false);
  const customStyle = useMemo(() => ({
    MAIN_SECTION_CLASSNAME: `p-top-${HEADER_PADDING_Y / 4}`,
    BACKGROUND_COLOR: SORBET,
    LEFT_GRADIENT_COLOR: SORBET,
    RIGHT_GRADIENT_COLOR: CANDY_APPLE,
    SEARCH_PADDING_BOTTOM: paddingBottom
  }), [paddingBottom]);
  return /*#__PURE__*/_jsx(CoreStorefrontHeader, {
    collapsedTitle: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "marketplaceUnified.pageTitle"
    }),
    customStyle: customStyle,
    onStickyChange: evt => setSticky(evt.target.value),
    subtitle: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "marketplaceUnified.pageSubtitle"
    }),
    testId: "storefront-header",
    title: /*#__PURE__*/_jsx(H1, {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "marketplaceUnified.pageTitle"
      })
    }),
    children: /*#__PURE__*/_jsx(SearchBar, {
      onTrackInteraction: onTrackInteraction,
      sticky: sticky
    })
  });
}